export const root = "rciosre";
export const guideLine = "g174rd6r";
export const guidePhoto = "gu0z0r2";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");